import {Repository} from './Repository'

export default {
  getTemplate () {
    return Repository.get('/api/getBalanceSheetTemplate')
  },
  postBalanceSheet (data) {
    return Repository.post('api/financialStatment', data)
  },
  updateBalanceSheet (data, fsID) {
    return Repository.post(`api/updatefinancialStatment/${fsID}`, data)
  },
  getMiscData () {
    return Repository.get('getInputPageData')
  },
  userFinancialStatements (data) {
    return Repository.post('api/userFinancialStatements', data)
  },
  getFinancialStatement (data) {
    let financialStatementId = data.financialStatementId
    return Repository.get('api/getFinancialStatement/' + financialStatementId)
  },
  deleteFinancialStatment (data) {
    return Repository.post('api/deleteFinancialStatment', data)
  },
  editFinancialStatement (data) {
    let financialStatementId = data.id
    return Repository.get('api/editFinancialStatement/' + financialStatementId)
  },
  getMockAssessmentEntries () {
    return Repository.get('api/mockEntries')
  }
}



// WEBPACK FOOTER //
// ./src/repositories/transformationInputOneRepository.js